<template src="./DataDetail.html"></template>
<style src="./DataDetail.css"></style>

<script>
import moment from "moment";

import store from "@/store/index";

export default {
  props: ["CLICODIGO"],
  data() {
    return {
      detailHeaders: [
        {
          text: "Número da venda",
          value: "VENNUMERO"
        },
        {
          text: "Data da venda",
          value: "VENDTEMISSAO"
        },
        {
          text: "Situação",
          value: "VENRNFCESITUACAO"
        },
        {
          text: "Chave de acesso",
          value: "VENRNFCECHAVE"
        },
        {
          text: "Rejeição",
          value: "VENRNFCEREJEICAO"
        }
      ],
      detailPagination: { rowsPerPage: 10 },
      detailRowsPerPageItems: [
        {
          text: "10",
          value: 10
        },
        {
          text: "25",
          value: 25
        },
        {
          text: "50",
          value: 50
        },
        {
          text: "100",
          value: 100
        },
        {
          text: "300",
          value: 300
        },
        {
          text: "500",
          value: 500
        },
        {
          text: "Todos",
          value: -1
        }
      ],
      copySuccessfully: false
    };
  },
  methods: {
    venDtEmissaoToDate(_venDtEmissao) {
      return moment(_venDtEmissao).format("DD/MM/YYYY");
    },
    venRNFCeSituacao(_venRNFCeSituacao) {
      switch (_venRNFCeSituacao) {
        case 0:
          return "Aberto";
        case 1:
          return "Confirmado";
        case 2:
          return "Cancelado";
        case 3:
          return "Pendente de autorização";
        case 4:
          return "Pendente de cancelamento";
        default:
          return "Desconhecido";
      }
    },
    copyKeyToClipBoard() {
      this.copySuccessfully = true;
      setTimeout(() => {
        this.copySuccessfully = false;
      }, 5000);
    }
  },
  computed: {
    isXs() {
      return store.state.window.isXs;
    },
    detail() {
      var dataDetail = [];
      store.state.vendaRapidaNFCe.dataDetail.forEach(element => {
        if (element.length > 0)
          if (element[0].CLICODIGO == this.CLICODIGO) dataDetail = element;
      });
      return dataDetail;
    },
    loadingDataDetail() {
      return store.state.vendaRapidaNFCe.loadingDataDetail;
    }
  }
};
</script>

